module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_schlafzimmer_oben_links_03.a435d049.jpg";